export class AuditSpecialist {
    SpecialistId: number;
    Name: string;
    InUse: boolean;
    ModifiedBy: string;
    ModifiedDate: Date;
    CreatedBy: string;
    CreateDate: Date;
}
